import httpService from '@Utils/httpService';

const baseUrl = 'api/areas';

export default {
	get(params, config = {}) {
		return httpService.get({
			url: `${baseUrl}/typeHead`,
			params,
			...config,
		});
	},
	add(data) {
		return httpService.post({
			url: baseUrl,
			data,
		});
	},
	update(data) {
		if (!data.id) return this.add(data);
		return httpService.put({
			url: `${baseUrl}/${data.id}`,
			data,
		});
	},
	del(id) {
		return httpService.delete({
			url: `${baseUrl}/${id}`,
		});
	},
	updateSelectedAreaId(data) {
		return httpService.post({
			url: `${baseUrl}/updateSelectedArea`,
			data
		});
	},
	removeTagsOutsideArea(id, box) {
		return httpService.delete({
			url: `${baseUrl}/removeTagsOutsideArea/${id}`,
			data: box,
		});
	},
}